// extracted by mini-css-extract-plugin
module.exports = {"modal":"member-status-info_modal__3P33K","title":"member-status-info_title__2quY7","desc":"member-status-info_desc__3urmf"};